// Temporärer Frontend-Schalter für Plattformen, die gerade keine Daten liefern.
// Eintrag entfernen, sobald die Plattform wieder läuft — alles andere greift automatisch.
export const TEMPORARILY_UNAVAILABLE_PLATFORMS = []

export function isPlatformTemporarilyUnavailable(key) {
    return TEMPORARILY_UNAVAILABLE_PLATFORMS.includes((key || "").toString().trim().toLowerCase())
}

// "A", "A and B", "A, B and C"
export function joinPlatformNames(names = []) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean)
    if (list.length <= 1) return list.join("")
    return list.slice(0, -1).join(", ") + " and " + list[list.length - 1]
}

// Kurzer Hinweis unter dem Plattform-Select
export function unavailableHintText(names = []) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean)
    if (!list.length) return ""
    return list.length === 1 ? list[0] + " temporarily unavailable" : list.length + " platforms temporarily unavailable"
}

// Tooltip zum Hinweis
export function unavailableTooltipText(names = []) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean)
    if (!list.length) return ""
    return joinPlatformNames(list) + (list.length === 1 ? " is" : " are") + " temporarily unavailable. All other platforms are not affected."
}

// Meldung, wenn ein Projekt nur aus nicht verfügbaren Plattformen besteht
export function unavailableOpenBlockedText(names = []) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean)
    if (!list.length) return ""
    const one = list.length === 1
    return joinPlatformNames(list) + (one ? " is" : " are") + " temporarily unavailable. This project cannot be opened until " + (one ? "the platform is" : "these platforms are") + " available again."
}
